// AUTO-GENERATED by bin/extract_legal_docs.py — do not edit by hand.
// Source: acceptable_use.md (canonical markdown)
// Generated text hash (sha256): a78f29ec43a90195e2c22b6df569ddb858b32b7721477d35d65f467e4c0d90ec

const content = `XPERT.COMPANY

operating xpert.company

Acceptable Use Policy

Conduct rules for users, Experts and integrators

Version 1.1 · Effective 8 July 2026 · Issued by the Office of the Chief Legal & Compliance Officer (CLCO)

# 1. Scope

This Acceptable Use Policy ("AUP") applies to everyone who accesses or uses the xpert.company marketplace, the API, the iOS or Android apps, or any other Xpert.Company product. The AUP is incorporated into the Terms of Service and the Expert Agreement.

# 2. You will not

Engage in unlawful conduct, including fraud, money laundering, terrorist financing, bribery, modern slavery, or breach of sanctions.

Provide advice that constitutes regulated professional practice (including legal, medical, financial, investment, tax, or immigration advice) unless you hold every licence or authorisation required in the jurisdiction(s) in which you are practising and in which the advice will be relied upon, and you restrict your advice to what those authorisations permit.

Use the Service to provide medical, clinical, diagnostic, or mental-health treatment advice of any kind. The Service is not a healthcare service and must not be used for the practice of medicine.

Use the Service to provide personalised investment advice, securities recommendations, or any service requiring registration as an investment adviser, broker-dealer, or equivalent. Finance Experts may provide operational and strategic finance input only, not regulated investment or securities advice.

Harass, threaten, defame, stalk, intimidate, or discriminate on the basis of a protected characteristic.

Post or share sexual content involving minors (zero tolerance — reported to authorities and removed permanently).

Post or share content that is sexually explicit, gratuitously violent, hateful, or that encourages self-harm.

Infringe another person's intellectual property, privacy, publicity, or other rights.

Misrepresent your identity, credentials, certifications, affiliations, or qualifications.

Solicit users off-platform in a way that avoids our fees in breach of the Expert Agreement.

Record any session or any communication on or off the Service without the express consent of all participants.

Reverse-engineer, decompile, scrape, or circumvent the Service's security or rate limits, except as expressly permitted.

Use the Service to send spam, unsolicited marketing, malware, phishing, or any content that violates anti-spam law (CAN-SPAM, CASL, the EU ePrivacy Directive and GDPR, UAE TDRA rules, India TRAI rules).

Use the Service to access from, on behalf of, or for the benefit of comprehensively sanctioned jurisdictions, parties on the OFAC SDN, UK OFSI, EU consolidated, UN consolidated, or PEP / adverse-media lists.

Use the Service in connection with weapons of mass destruction, military or surveillance technologies prohibited by EU/US/UK/UAE export-control regimes.

Use the Service or AI-generated outputs to make securities offerings, deepfakes, fake reviews, or manipulated likenesses of real people without their consent.

# 3. Content we will remove on notice

Content reported through our notice-and-action mechanism that is illegal under EU/UK law (DSA-aligned takedown).

Content that infringes copyright per a properly formed notice (DMCA-style).

Content that violates UAE Cybercrime Law (defamation, religious insult, content that incites public disorder).

Content that violates Indian IT Rules 2021 grievance escalation.

# 4. Reporting

Report content via xpert.company/legal/report or by email to abuse@xpert.company. We will acknowledge promptly and respond within statutory or platform-promised timeframes (typically 7 days; faster for safety-critical reports).

# 5. Consequences

We may, at our discretion and proportionate to the conduct: warn, remove content, restrict features, suspend the account, terminate the account, refund affected users, withhold payouts, refer to law enforcement, or pursue civil remedies. We operate a repeat-infringer policy and will, in appropriate cases, terminate the accounts of users who repeatedly infringe. As a guide, three or more substantiated infringement notices within any 12-month period will normally result in termination, though we may act sooner where the conduct warrants it.
`;

export default content;
